import { Injectable } from '@angular/core';

import { EnvUtils, StoreService } from '@ecm/dispatcher';

import { Transaction } from '../enums/transaction';
import { AccessCodeUtils } from '../utils/access-code.utils';
import { EnvironmentService } from './environment.service';
import { UaService } from './ua-service';

@Injectable({
    providedIn: 'root',
})
export class BcoCsvFormatter {
    /**
     * Session Object keys
     * @type {string}
     */
    private readonly ID_KEY: string = 'id';

    public constructor(
        private uaService: UaService,
        private envService: EnvironmentService,
    ) {}

    /**
     * Format a transaction into a single CSV-formatted BCO log string
     * @return {string} CSV-formatted BCO log
     */
    public format(transaction: Transaction): string {
        const env = this.envService.instant();
        const accessCode: string = AccessCodeUtils.getAccesCodeFromEnvironment(env);
        const sessionId: string = StoreService.get('session')[this.ID_KEY];
        const duration: number = new Date(transaction.endDate).getTime() - new Date(transaction.startDate).getTime();
        const equipment: string = this.uaService.getDeviceType();
        const appVersion: string = EnvUtils.version || '0.0.0';
        const OSName: string = this.uaService.getOSName();
        const OSVersion: string = this.uaService.getOSVersion();
        const browserName: string = this.uaService.getBrowserName();

        const formattedLog: any[] = [
            transaction.startDate,
            transaction.endDate,
            duration,
            sessionId,
            transaction.pageId,
            transaction.id,
            accessCode,
            transaction.feature,
            transaction.functionality,
            transaction.partner,
            transaction.httpMethod,
            transaction.service,
            '0',
            equipment,
            OSName,
            OSVersion,
            browserName,
            transaction.status,
            transaction.code,
            transaction.errorMessage,
            appVersion, // this data is out of bound and will not be sent to PUC, only logged for debug purpose
        ];

        // optionaly adds the "retry" commentary
        if (transaction.commentary) {
            formattedLog.push(transaction.commentary);
        }

        return formattedLog.join(';');
    }
}
